/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDashboard = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h20v15h-9v3h4v2H7v-2h4v-3H2zm2 2v11h16V4zm6.045 1.13 3.153 5.257L14.586 9H18v2h-2.586l-2.612 2.613L9.956 8.87 8.536 11H6V9h1.465z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDashboard as Dashboard };
